import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Tooltip, Legend, Polygon } from 'recharts';
import styles from "./index.module.scss";



const company1Data = {
    name: 'Company 1',
    priceQualityPercentage: 80,
    winPercentage: 70,
    size: Math.log10(325000)*10,
    competitors: 57,
    experience: 90,
} 

const company2Data = {
    name: 'Company 2',
    priceQualityPercentage: 60,
    winPercentage: 50,
    size: Math.log10(200000) * 10,
    competitors: 20,
    experience: 30,
}


const data = [
    { subject: 'Price', A: company1Data.priceQualityPercentage, B: company2Data.priceQualityPercentage, fullMark: 100 },
    { subject: 'Win %', A: company1Data.winPercentage, B: company2Data.winPercentage, fullMark: 100 },
    { subject: 'Size', A: company1Data.size, B: company2Data.size, fullMark: 400000 },
    { subject: 'Quality', A: 100 - company1Data.priceQualityPercentage, B: 100 - company2Data.priceQualityPercentage, fullMark: 100 },
    { subject: 'Competitors', A: company1Data.competitors, B: company2Data.competitors, fullMark: 50 },
    { subject: 'Experience', A: company1Data.experience, B: company2Data.experience, fullMark: 10 },
];

export const CompanyOverviewRadar = () => (<div className={styles['radar-container']}>
    <RadarChart cx={300} cy={250} outerRadius={150} width={500} height={460} data={data}>
        <PolarGrid />
        <PolarAngleAxis dataKey="subject" tick={true} />
        <PolarRadiusAxis domain={[0, 100]} tick={false} />
        <Radar name={company1Data.name} dataKey="A" stroke="orange" fill="orange" fillOpacity={0.4} />
        <Legend verticalAlign="bottom" align="center" layout="vertical"/>
    </RadarChart>

    <RadarChart cx={300} cy={250} outerRadius={150} width={500} height={460} data={data}>
        <PolarGrid />
        <PolarAngleAxis dataKey="subject" tick={true} />
        <PolarRadiusAxis domain={[0, 100]} tick={false} />
        <Radar name={company1Data.name} dataKey="A" stroke="orange" fill="orange" fillOpacity={0.4} />
        <Radar name={company2Data.name} dataKey="B" stroke="blue" fill="blue" fillOpacity={0.4} />
    </RadarChart>

    <RadarChart cx={300} cy={250} outerRadius={150} width={500} height={460} data={data}>
        <PolarGrid />
        <PolarAngleAxis dataKey="subject" tick={true} />
        <PolarRadiusAxis domain={[0, 100]} tick={false} />
        <Radar name={company2Data.name} dataKey="B" stroke="blue" fill="blue" fillOpacity={0.4} />
        <Legend />
    </RadarChart>
</div>);
